const translations: Record<string, string> = {
  "ak_fin2_uah_mwh": "{{v}} грн/МВт·год",
  "ak_fin2_dam": "РДН",
  "ak_fin2_index": "індекс",
  "ak_fin2_confirm": "Підтвердити?",
  "ak_fin2_no_terms_yet": "Умов ще немає.",
  "ak_fin2_press_add_term": "Натисніть «Додати умову».",
  "ak_fin2_term_activated": "Умову активовано.",
  "ak_fin2_term_completed": "Умову завершено.",
  "ak_fin2_failed_to_change_the_status": "Не вдалося змінити статус",
  "ak_fin2_draft_deleted": "Чернетку видалено.",
  "ak_fin2_failed_to_delete": "Не вдалося видалити",
  "ak_fin2_saved": "Збережено.",
  "ak_fin2_terms_directory": "Довідник умов",
  "ak_fin2_add_term": "Додати умову",
  "ak_fin2_asset": "Об’єкт",
  "ak_fin2_seller": "Продавець",
  "ak_fin2_buyer": "Покупець",
  "ak_fin2_sale_type": "Тип продажу",
  "ak_fin2_model": "Модель",
  "ak_fin2_price_formula": "Ціна / формула",
  "ak_fin2_validity_period": "Період дії",
  "ak_fin2_vat": "ПДВ",
  "ak_fin2_status": "Статус",
  "ak_fin2_actions": "Дії",
  "ak_fin2_loading": "Завантаження…",
  "ak_fin2_incl_vat": "з ПДВ",
  "ak_fin2_excl_vat": "без ПДВ",
  "ak_fin2_edit": "Редагувати",
  "ak_fin2_activate": "Активувати",
  "ak_fin2_complete": "Завершити",
  "ak_fin2_confirm_draft_deletion": "Підтвердити видалення чернетки",
  "ak_fin2_delete_draft": "Видалити чернетку",
  "ak_fin2_the_database_enforces_the_rule_one_act": "База стежить за правилом «одна чинна умова на об’єкт+період»: активувати другу умову з перекриттям періоду не вийде.",
  "ak_fin2_price_x": "Ціна = {{base}} ± X%",
  "ak_fin2_price": "Ціна = {{base}} {{sign}} {{n}}%",
  "ak_fin2_rounded_to_2_decimals_final_hourly_pri": "округлення до 2 знаків, лише кінцева погодинна ціна",
  "ak_fin2_failed_to_save": "Не вдалося зберегти",
  "ak_fin2_edit_term": "Редагувати умову",
  "ak_fin2_new_purchase_and_sale_term": "Нова умова купівлі-продажу",
  "ak_fin2_asset_and_parties": "Об’єкт і сторони",
  "ak_fin2_asset_2": "Об’єкт *",
  "ak_fin2_select_an_asset": "— оберіть об’єкт —",
  "ak_fin2_short_name": "Скорочена назва",
  "ak_fin2_buyer_type": "Тип покупця *",
  "ak_fin2_contract_and_period": "Договір і період",
  "ak_fin2_contract_number": "Номер договору",
  "ak_fin2_contract_date": "Дата договору",
  "ak_fin2_valid_from": "Початок дії *",
  "ak_fin2_valid_to": "Кінець дії *",
  "ak_fin2_sale_type_2": "Тип продажу *",
  "ak_fin2_green_tariff_validity_end": "Строк дії зеленого тарифу",
  "ak_fin2_neurc_resolution_no_and_date": "Постанова НКРЕКП (№ і дата)",
  "ak_fin2_price_model": "Цінова модель",
  "ak_fin2_model_2": "Модель *",
  "ak_fin2_price_uah_mwh": "Ціна, грн/МВт·год *",
  "ak_fin2_base_index": "Базовий індекс *",
  "ak_fin2_markup_discount": "Надбавка/знижка, % *",
  "ak_fin2_other": "Інше",
  "ak_fin2_incl_vat_2": "З ПДВ",
  "ak_fin2_cancel": "Скасувати",
  "ak_fin2_saving": "Збереження…",
  "ak_fin2_save": "Зберегти",
  "ak_fin2_create": "Створити",
};

export default translations;
